var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Input } from "semantic-ui-react";
import FieldWithErrorDisplay from "../FieldWithErrorDisplay";
var AddOrderPoComment = /** @class */ (function (_super) {
    __extends(AddOrderPoComment, _super);
    function AddOrderPoComment(props) {
        var _this = _super.call(this, props) || this;
        _this.onMsgChange = function (event) {
            var val = event.currentTarget.value;
            _this.setState({
                msg: val
            });
        };
        _this.submit = function () {
            _this.props.postRequest("/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/po-uploads/id/" + encodeURIComponent(_this.props.poUploadId) + "/comment", {
                msg: _this.state.msg,
            });
        };
        _this.state = {
            msg: ''
        };
        return _this;
    }
    AddOrderPoComment.prototype.render = function () {
        return React.createElement(React.Fragment, null,
            React.createElement(FieldWithErrorDisplay, { errorPath: '/msg', errors: this.props.state.errors, required: true, labelContent: 'Message' },
                React.createElement(Input, { value: this.state.msg, onChange: this.onMsgChange })),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success || this.state.msg.length === 0, icon: 'plus', label: 'Add comment', labelPosition: 'left', onClick: this.submit, positive: true }));
    };
    return AddOrderPoComment;
}(React.PureComponent));
export default AddOrderPoComment;
//# sourceMappingURL=AddOrderPoComment.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/AddOrderPoComment.js
// module id = 1242
// module chunks = 0